import { UtilArray } from './UtilArray';
import { UtilString } from './UtilString';
import { isEqual, includes } from 'lodash';
export class UtilConflict {
    static getDiffs(currentDocument, remoteDocument) {
        const diffs = [];
        const remoteKeys = Object.keys(remoteDocument);
        const currentKeys = Object.keys(currentDocument);
        const unionKeys = UtilArray.union(remoteKeys, currentKeys);
        for (let k = 0; k < unionKeys.length; k++) {
            const key = unionKeys[k];
            if (key !== 'systemHeader') {
                const currentValue = JSON.stringify(currentDocument[key]);
                const remoteValue = JSON.stringify(remoteDocument[key]);
                if (currentValue !== remoteValue) { // compare as string
                    diffs.push({
                        fieldName: key,
                        currentValue: currentDocument[key],
                        remoteValue: remoteDocument[key]
                    });
                }
            }
        }
        return diffs;
    }
    static checkConflict(newUpdatesData, oldUpdatesData) {
        if (newUpdatesData && newUpdatesData.updates && oldUpdatesData && oldUpdatesData.updates) {
            for (let i = newUpdatesData.updates.length - 1; i >= 0; i--) {
                const change = newUpdatesData.updates[i];
                const path = UtilString.convertToObjectPath(change.path);
                // exclude systemHeader checking for serverDate, createdDate, createdBy, serverUpdatedDate, serverCreatedDate,
                // currentVersion and versionId - mantis 18242
                const excludeSystemHeaderProperties = ["systemHeader.serverDate", "systemHeader.createdDate", "systemHeader.createdBy",
                    "systemHeader.serverUpdatedDate", "systemHeader.serverCreatedDate", "systemHeader.currentVersion",
                    "systemHeader.versionId", "systemHeader.previousVersionId"];
                if (!includes(excludeSystemHeaderProperties, path)) {
                    for (let j = oldUpdatesData.updates.length - 1; j >= 0; j--) {
                        const jChange = oldUpdatesData.updates[j];
                        const jPath = UtilString.convertToObjectPath(jChange.path, '/');
                        // Old and new updates on the same field ==> conflict
                        if (path === jPath && !isEqual(change.value, jChange.value)) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
}
